import { configureStore } from '@reduxjs/toolkit';
import productReduce from './reducer/productSlice';
import paymentSlice from './reducer/paymentSlice';
import userSlice from './reducer/userSlice';
import promoCodeSlice from './reducer/promoCodeSlice';

const store = configureStore({
  reducer: {
    product: productReduce,
    payment: paymentSlice,
    user: userSlice,
    promotion: promoCodeSlice,
  },
});

export default store;

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

// export type AppDispatch = typeof store.dispatch
// export const useAppDispatch = () => useDispatch<AppDispatch>();
